/*
 * @Author: JakeChiu
 * @Emaiil: 3289011@qq.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2022-01-20 16:30:27
 * @LastEditTime: 2022-11-15 10:42:33
 * @LastEditors: JakeChiu
 * @Description: JakeChiu in HX at Do not edit
 * @FilePath: \visualh5\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import paymenapp from './components/payment.vue'
import paymentresultapp from './components/PaymentResult.vue'
import util from '@/util.js'
import './assets/css/css.css';
import Mint from 'mint-ui';
import "./assets/css/mintstyle.css";
Vue.config.productionTip = false
//装载自定义工具箱
Vue.use(util);
// 装载mint-ui
Vue.use(Mint);
new Vue({
// 根组件
  render: h => h(window.ispayment?paymenapp:(window.PaymentResult?paymentresultapp:App)),
}).$mount('#app')
